import { Link } from '@tanstack/react-router';
import { ArrowRight } from 'lucide-react';

/**
 * The "backwards" path into the onboarding checklist, surfaced inside help popovers that reference
 * it. The onboarding page guards its own status so revisiting here never regresses a finished
 * manager. Renders its own divider so it sits cleanly at the foot of a popover.
 */
export function OnboardingChecklistLink() {
  return (
    <Link
      to="/app/onboarding"
      className="mt-3 flex items-center gap-1.5 border-t pt-3 text-sm font-medium text-primary hover:underline"
    >
      Open onboarding checklist
      <ArrowRight className="h-3.5 w-3.5" />
    </Link>
  );
}
